import api from '@/api'

export default {
  namespaced: true,
  state: {
    types: [],
    type: null,
    latitude: 45.5,
    longitude: 25.5
  },
  mutations: {
    setTypes (state, types) {
      if (!Array.isArray(types)) {
        throw new Error('Invalid types')
      }
      state.types = types
    },
    setLatitude (state, latitude) {
      state.latitude = latitude
    },
    setLongitude (state, longitude) {
      state.longitude = longitude
    },
    setType (state, type) {
      const found = state.types.find((current) => current.id === type)
      if (!found) {
        throw new Error(`Invalid region ${type}`)
      }
      state.type = found
    }
  },
  actions: {
    async loadTypes ({ commit }) {
      const types = await api.loadRegions()
      commit('setTypes', types)
    }
  }
}
